import styled from 'styled-components'

import { SO } from '@h2/components/colors'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Skeleton } from '@h2/components/loading/skeleton'

import { fetchingStyles } from '../fetchingStyles'

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding: 10px;
  height: 120px;
  flex-basis: 50%;
  ${fetchingStyles}
`
const StatsCard = ({ title = '', value, isFetching = false }) => {
  if (isFetching) {
    return (
      <Wrap isFetching={isFetching}>
        <Skeleton display="block" height="105px" width="180px" />
      </Wrap>
    )
  }

  return (
    <Wrap isFetching={isFetching}>
      <Heading level="2" mb="3px" color={SO}>
        {value}
      </Heading>
      <Text size="small" align="center">
        {title}
      </Text>
    </Wrap>
  )
}

export { StatsCard }
